import * as Sentry from "@sentry/react";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useEffect } from "react";

import { getSupabaseBrowserClient } from "@/lib/supabase";

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const { code, next } = useSearch({ from: "/auth/callback" });
  const nextPath = next || "/";

  useEffect(() => {
    if (!code) {
      navigate({
        to: "/",
        search: { next: nextPath },
        replace: true,
      });
      return;
    }

    const supabase = getSupabaseBrowserClient();
    supabase.auth.exchangeCodeForSession(code).then(({ error }) => {
      if (error) {
        Sentry.captureMessage(`Auth callback failed: ${error.message}`, "error");
        navigate({
          to: "/",
          search: { next: nextPath, error: error.message },
          replace: true,
        });
      } else {
        navigate({ to: nextPath as "/", replace: true });
      }
    });
  }, [navigate, code, nextPath]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-950 text-white">
      <p className="text-lg">Signing in...</p>
    </div>
  );
}
